export * from './medicalDocument.model';
